import { IDashboardDataOptions } from '@interfaces/api/IDashboard'
import ProjectBudgetStats from '@components/chart/project/ProjectBudgetStats'
import { ComponentType } from 'react'
import ProjectBudgetByQuarter from '@components/chart/project/ProjectBudgetByQuarter'
import ProjectBudgetRanking from '@components/chart/project/ProjectBudgetRanking'
import ProjectEvaluationSummary from '@components/chart/project/ProjectEvaluationSummary'
import ProjectEvaluationRanking from '@components/chart/project/ProjectEvaluationRanking'
import ProjectBudgetByType from '@components/chart/project/ProjectBudgetByType'
import ProjectRegisteredStats from '@components/chart/project/ProjectRegisteredStats'
import AgencyNewAndOldStats from '@components/chart/agency/AgencyNewAndOldStats'
import AgencyNewAndOldLists from '@components/chart/agency/AgencyNewAndOldLists'
import AgencyAmountByType from '@components/chart/agency/AgencyAmountByType'
import AgencyBudgetByType from '@components/chart/agency/AgencyBudgetByType'
import AgencyBudgetRanking from '@components/chart/agency/AgencyBudgetRanking'
import CoordinatorEvaluationWithBudgetRanking from '@components/chart/coordinator/CoordinatorEvaluationWithBudgetRanking'
import ChairmanNewAndOldStats from '@components/chart/chairman/ChairmanNewAndOldStats'
import ChairmanNewAndOldLists from '@components/chart/chairman/ChairmanNewAndOldLists'
import ChairmanEvaluationWithBudgetRanking from '@components/chart/chairman/ChairmanEvaluationWithBudgetRanking'
import LecturerEvaluationRanking from '@components/chart/lecturer/LecturerEvaluationRanking'
import VendorNewAndOldStats from '@components/chart/vendor/VendorNewAndOldStats'
import VendorNewAndOldLists from '@components/chart/vendor/VendorNewAndOldLists'
import VendorEvaluationRanking from '@components/chart/vendor/VendorEvaluationRanking'

type DashboardOptionProps = {
  key: keyof IDashboardDataOptions
  label: string
  component?: ComponentType<any>
}[]

export const singleYearDashboardProjectOptions: DashboardOptionProps = [
  { key: 'opt_project_budget_stats', label: 'สถิติยอดจำนวนโครงการ และมูลค่าของโครงการทั้งหมด (Stats)', component: ProjectBudgetStats },
  { key: 'opt_project_budget_by_quarter', label: 'ยอดมูลค่าโครงการทั้งหมดแบ่งสัดส่วนตามไตรมาส (Column Chart)', component: ProjectBudgetByQuarter },
  {
    key: 'opt_project_budget_ranking',
    label: 'จัดอันดับโครงการสำคัญที่มียอดมูลค่าโครงการสูงสุด 10 อันดับแรก (Table Bar Chart)',
    component: ProjectBudgetRanking,
  },
  {
    key: 'opt_project_budget_by_type',
    label: 'ยอดมูลค่าโครงการทั้งหมด แบ่งสัดส่วนตามประเภทกิจกรรมบริการวิชาการ (Pie Chart)',
    component: ProjectBudgetByType,
  },
  { key: 'opt_project_evaluation_summary', label: 'ภาพรวมความพึงพอใจโครงการ (Column Chart)', component: ProjectEvaluationSummary },
  {
    key: 'opt_project_evaluation_ranking',
    label: 'จัดอันดับโครงการที่มีคะแนนความพึงพอใจสูงสุด 10 อันดับแรก (Table Bar Chart)',
    component: ProjectEvaluationRanking,
  },
  {
    key: 'opt_project_registered_stats',
    label: 'สถิติยอดจำนวนผู้เข้าร่วม จำนวนโครงการ และมูลค่าโครงการทั้งหมด (เฉพาะโครงการเก็บค่าลงทะเบียน) (Stats)',
    component: ProjectRegisteredStats,
  },
]
export const singleYearDashboardAgencyOptions: DashboardOptionProps = [
  {
    key: 'opt_agency_new_and_old_stats',
    label: 'สถิติยอดจำนวนลูกค้าทั้งหมด และจำนวนลูกค้ารายเก่าและลูกค้ารายใหม่ (Stats)',
    component: AgencyNewAndOldStats,
  },
  { key: 'opt_agency_new_and_old_lists', label: 'รายชื่อลูกค้ารายเก่าและรายใหม่ (Table)', component: AgencyNewAndOldLists },
  { key: 'opt_agency_amount_by_type', label: 'ยอดจำนวนลูกค้าทั้งหมด แบ่งสัดส่วนตามประเภทหน่วยงาน (Pie Chart)', component: AgencyAmountByType },
  { key: 'opt_agency_budget_by_type', label: 'ยอดมูลค่าโครงการทั้งหมด แบ่งสัดส่วนตามประเภทหน่วยงาน (Pie Chart)', component: AgencyBudgetByType },
  {
    key: 'opt_agency_budget_ranking',
    label: 'จัดอันดับลูกค้าสำคัญที่มียอดมูลค่าโครงการสูงสุด 10 อันดับแรก (Table Bar Chart)',
    component: AgencyBudgetRanking,
  },
]
export const singleYearDashboardOtherOptions: DashboardOptionProps = [
  {
    key: 'opt_coordinator_evaluation_with_budget_ranking',
    label: 'จัดอันดับผู้ประสานงานโครงการที่มียอดมูลค่าโครงการสูงสุด 10 อันดับแรก พร้อมค่าเฉลี่ยคะแนนความพึงพอใจโครงการ (Table Bar Chart)',
    component: CoordinatorEvaluationWithBudgetRanking,
  },
  {
    key: 'opt_chairman_new_and_old_stats',
    label: 'สถิติยอดจำนวนประธานโครงการทั้งหมด และจำนวนประธานโครงการรายเก่าและรายใหม่ (Stats)',
    component: ChairmanNewAndOldStats,
  },
  { key: 'opt_chairman_new_and_old_lists', label: 'รายชื่อประธานโครงการรายใหม่และรายเก่า (Table)', component: ChairmanNewAndOldLists },
  {
    key: 'opt_chairman_evaluation_with_budget_ranking',
    label: 'จัดอันดับประธานโครงการที่มียอดมูลค่าโครงการสูงสุด 10 อันดับแรก พร้อมค่าเฉลี่ยคะแนนความพึงพอใจโครงการ (Table Bar Chart)',
    component: ChairmanEvaluationWithBudgetRanking,
  },
  {
    key: 'opt_lecturer_evaluation_ranking',
    label: 'จัดอันดับวิทยากรที่ได้รับค่าเฉลี่ยผลการประเมินคะแนนความพึงพอใจสูงสุด 10 อันดับแรก (Table)',
    component: LecturerEvaluationRanking,
  },
  {
    key: 'opt_vendor_new_and_old_stats',
    label: 'สถิติยอดจำนวนผู้ค้าทั้งหมด และจำนวนผู้ค้ารายใหม่และรายเก่า (Stats)',
    component: VendorNewAndOldStats,
  },
  { key: 'opt_vendor_new_and_old_lists', label: 'รายชื่อผู้ค้ารายใหม่และรายเก่า (Table)', component: VendorNewAndOldLists },
  {
    key: 'opt_vendor_evaluation_ranking',
    label: 'จัดอันดับผู้ค้าที่ได้รับค่าเฉลี่ยผลการประเมินคะแนนความพึงพอใจสูงสุด 10 อันดับแรก (Table)',
    component: VendorEvaluationRanking,
  },
]
